//Angular
import { Component, OnInit, ViewContainerRef, Inject, Compiler, Input } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';

//Services
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { QuotingService } from "./../../../../services/document/quoting.service";
import { LanguageService } from "./../../../../services/cms/language.service";
import { AuthService } from "./../../../../services/core/auth.service";
import { BootboxService } from './../../../../services/core/bootbox.service';
import { ShoppingCartService } from "./../../../../services/inventory/shopping-cart.service";
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";

//Models
import { LavorazioniAccessorieModel } from "./../../../../models/document/quoting-submit-model";
import { UserLogin } from "./../../../../models/cms/user-login";
import { PriceEstimationModel } from "./../../../../models/document/quoting-submit-model";
import { wizardFormEditoriaModel } from "./../../../../models/document/quoting-submit-model";
import { QuotingConstants } from './../../../../models/constants/quoting-constants';

import { Subscription } from 'rxjs/Subscription';
import { ExcludingComponent } from "./quoting-excluding.component";
import { SharedConstants } from "../../../../models/constants/shared-constants";
import { QuotingModel, MyLavorazioneAccessoria } from "../../../../models/document/quoting-model";

@Component({
    selector: "dy-other-product-quoting-form",
    template: ""
})


export class OtherProductFormComponent implements OnInit {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private authService: AuthService,
            private languageService: LanguageService,
            private cmsComponentService: CmsComponentService,
            @Inject('isBrowser') private isBrowser: boolean
        ) { }

    @Input() productId: string;

    autentification = this.authService.GetData();
    lang: string = this.languageService.getLongLang();
    private userId = this.authService.GetUserId();

    subManager = new Subscription();

    ngOnInit() {
        if (!this.isBrowser) {
            return;
        }

        //Instead of reading only the template, also the information to show are retrieved (eg. menu list)
        let otherProdSub = this.cmsComponentService.getOtherProductData(this.productId, this.userId).subscribe(result => {
            //Creating subcomponent whith the selected template to inject
            let subComponent = this.createSubComponent(result, this.productId);

            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        });

        this.subManager.add(otherProdSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(formInfo: any, InputresourceId: string) {

        @Component({
            template: formInfo.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor
                (
                    private _quotingService: QuotingService,
                    private authService: AuthService,
                    private translate: TranslateService,
                    private cartService: ShoppingCartService,
                    private bootboxService: BootboxService,
                    @Inject('isBrowser') private isBrowser: boolean
                ) { }

            formData = formInfo.FormData;
            private pageIsInit: boolean = false;
            private loggedIdUser: UserLogin;
            resourceId: string = InputresourceId;
            model = new wizardFormEditoriaModel();
            resultPrice: PriceEstimationModel = new PriceEstimationModel();
            resultCalculation: boolean = false;
            isDataInitialized: boolean = false;
            requestInfoSuccess: boolean = null;
            showErrorMessage: boolean = false;
            companyInformation = formInfo.CompanyInfo;
            isFormValid: boolean = true;
            currentRowIndex: number = -1;
            currentColumnIndex: number = -1;
            typePriceResult: string;
            copieMessage: string;

            isCalculatedProduct: boolean = false;

            private ExcludingRules: ExcludingComponent = new ExcludingComponent();
            private responseModel: QuotingModel = new QuotingModel();

            subManager = new Subscription();

            ngOnInit() {
                var array = ["1", "2", "3"];
                this.resultPrice.TablePriceList = new Array<any>();
                this.resultPrice.TablePriceList.push(array);
                this.resultPrice.TableScontisticaPriceList = new Array<Array<any>>();
                this.resultPrice.TableScontisticaPriceList.push(array);
                this.typePriceResult = "no-tax";

                this.ExcludingRules.setMacrocategory(SharedConstants.OTHER_PRODUCTS_TYPE);

                this.loggedIdUser = this.authService.GetData();
                this.responseModel = new QuotingModel();

                if (!this.isDataInitialized) {
                    this.convertLogicalToViewQuotingModel();
                    this.checkValidation()
                }
            }

            //-- Create quoting object from form data object, because we need it for applying rules(regole)
            private convertLogicalToViewQuotingModel() {
                this.responseModel.listaRegole = this.formData.listaRegole;
                this.responseModel.calculationType = this.formData.calculationType;
                this.responseModel.companyCondizioni = this.formData.companyCondizioni;
                this.responseModel.lavorazioniAccessorie = [];

                //-- From gruppi obect get all varianti and convert it to Lavorazioni Accessorie model
                this.formData.gruppi.forEach(group => {
                    group.varianti.forEach(varianti => {
                        let lavAcc = this.convertLogicalToViewModelVarianti(varianti);

                        this.responseModel.lavorazioniAccessorie.push(lavAcc);
                    });
                });
            }

            //-- Convert varianti model to lavorazioni accessorie model
            private convertLogicalToViewModelVarianti(varianti) {
                let lavAcc: MyLavorazioneAccessoria = new MyLavorazioneAccessoria();

                lavAcc.id = varianti.id;
                lavAcc.obbligatorio = varianti.obbligatorio;
                lavAcc.tipo = varianti.tipo;
                lavAcc.description = varianti.description;
                lavAcc.hasInfo = varianti.hasInfo;
                lavAcc.showInfo = varianti.showInfo;
                lavAcc.isVisible = varianti.isVisible;
                lavAcc.image = varianti.image;
                lavAcc.value = varianti.value;
                lavAcc.valori = varianti.valori;
                lavAcc.lavorazioneCheckValue = (varianti.lavorazioneCheckValue == 'true');
                lavAcc.isCalculated = varianti.isCalculated;
                lavAcc.tipoSelezione = varianti.tipoSelezione;
                //--If type is numeric or dropdown, valore is intFormValue, else it is valore
                if (varianti.tipo == 1 || varianti.tipo == 2) {
                    lavAcc.valore = varianti.intFormValue;
                }
                else {
                    lavAcc.valore = varianti.valore;

                }

                return lavAcc;
            }

            checkRegoleOtherProducts() {
                try {
                    let lavAccArray = new Array<LavorazioniAccessorieModel>();
                    for (let lavorazione of this.responseModel.lavorazioniAccessorie) {
                        let lav: LavorazioniAccessorieModel = new LavorazioniAccessorieModel();
                        if (lavorazione.tipo == "2") {
                            lav.lavorazioneId = lavorazione.id;
                            lav.valoreLavorazione = lavorazione.valore;
                            lavAccArray.push(lav);
                        }
                    }

                    //-----------------------------------------------------------------------------//
                    //-----------------------------Reset delle regole------------------------------//
                    //-----------------------------------------------------------------------------//

                    this.ExcludingRules.ResetRegole("AP", "ACCESSORIA", "", "ALTRO_PRODOTTO", null, null, this.responseModel, this.formData.gruppi);

                    //-----------------------------------------------------------------------------//
                    //----------------------Applicazione delle regole------------------------------//
                    //-----------------------------------------------------------------------------//

                    this.ExcludingRules.ApplicaRegoleLavorazioniAccessorie("AP", "ALTRO_PRODOTTO", this.responseModel, this.formData.gruppi);
                }
                catch (error) {
                    this.showErrorMessage = true;
                    return;
                }
            }

            checkBoxChanged(lavorazione) {
                //-- Updating lavorazioniAccessorie model
                for (let variante of this.responseModel.lavorazioniAccessorie) {
                    if (variante.id == lavorazione.id) {
                        variante.hasInfo = lavorazione.hasInfo;
                        variante.lavorazioneCheckValue = (lavorazione.lavorazioneCheckValue == 'true');
                        variante.valore = lavorazione.intFormValue;
                        break;
                    }
                }

                this.convertLogicalToViewQuotingModel();
                this.checkValidation();
            }

            dropDownChange(lavorazione) {
                //-- Setting option description (if there is)
                for (let variante of lavorazione.valori) {
                    if (lavorazione.intFormValue == variante.chiave) {
                        lavorazione.description = variante.descrizione;
                        lavorazione.image = variante.image;
                        lavorazione.hasInfo = variante.hasInfo;
                        lavorazione.showInfo = false;

                        break;
                    }
                }

                //-- Updating lavorazioniAccessorie model
                for (let variante of this.responseModel.lavorazioniAccessorie) {
                    if (variante.id == lavorazione.id) {
                        variante.hasInfo = lavorazione.hasInfo;
                        variante.valore = lavorazione.intFormValue;
                        break;
                    }
                }

                this.checkValidation()
            }

            lavorazioniAccessorieComboVisualChange(lavorazioneId, lavorazione) {
                lavorazione.intFormValue = lavorazioneId;
                this.dropDownChange(lavorazione);
            }

            checkValidation() {
                this.isCalculatedProduct = false;
                this.resultCalculation = false;
                this.showErrorMessage = false;

                this.checkRegoleOtherProducts();

                this.checkForm();
                if (this.isFormValid) {
                    $('#quotingFormCalculationLoader').addClass("overBlock");
                    this.getCalculationModel()
                }

                else {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    this.resultCalculation = true;
                    this.showErrorMessage = true;
                }
            }

            checkFormRichiestaPrevIsValid() {
                let result: boolean = false;

                if (this.formData.calculationType == QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_RICHIESTA_PREVENTIVO && !this.isCustomerLoggedIn()) {
                    if (this.model.richiestaName != ""
                        && this.model.richiestaSubName != ""
                        && this.model.isRichiestaEmailValid
                        && this.model.richiestaTelephone != ""
                        && this.model.richiestaJobname != ""
                        && this.model.richiestaCondizioni) {
                        result = true;
                    }
                }
                else if (this.formData.calculationType == QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_RICHIESTA_PREVENTIVO && this.isCustomerLoggedIn()) {
                    if (this.model.richiestaJobname != "") {
                        result = true;
                    }
                }

                return result;
            }

            sendRequestInfo() {
                if (this.checkFormRichiestaPrevIsValid()) {
                    let sub = this._quotingService.sendRequestInfo(this.model).subscribe(result => {
                        if (result == true) {
                            this.requestInfoSuccess = true;
                        }
                        else {
                            this.requestInfoSuccess = false;
                        }
                    },
                        err => {
                            this.requestInfoSuccess = false;
                        }
                    );

                    this.subManager.add(sub);
                }
            }

            showHideLavDescription(lavorazione) {
                if (lavorazione.showInfo) {
                    lavorazione.showInfo = false;
                }

                else {
                    lavorazione.showInfo = true;
                }
            }

            checkForm() {
                if (this.isCalculationTypeCalcolato() || this.isCalculationTypeCalcolatoScontistica()) {
                    let message;
                    let numCopie = parseInt(this.formData.quantity);
                    let minCopie = this.formData.minimo_quantita;
                    let maxCopie = this.formData.maximo_quantita;

                    //Quantity
                    if (this.formData.quantity == null || numCopie <= 0) {
                        message = this.getLabel('inserisci_valore_valido');
                        this.formData.isQuantityValidated = false;
                        if (this.isFormValid == true) {
                            this.isFormValid = false;
                        }
                    }
                    else if (maxCopie == 0||this.formData.maximo_quantita == null ) {
                        if (numCopie < minCopie) {
                            message = this.getLabel('inserisci_valore_maggiore');
                            message += " " + minCopie;
                            this.formData.isQuantityValidated = false;
                            if (this.isFormValid == true) {
                                this.isFormValid = false;
                            }
                        }
                        else {
                            this.formData.isQuantityValidated = true;
                            this.isFormValid = true;
                        }
                    }
                    else {
                        if ((numCopie >= minCopie) && (numCopie <= maxCopie)) {
                            this.formData.isQuantityValidated = true;
                            this.isFormValid = true;
                        }
                        else {
                            message = this.getLabel('inserisci_valore_compreso_tra');
                            message += " " + minCopie;
                            message += " " + this.getLabel('inserisci_valore_compreso_e');
                            message += " " + maxCopie;
                            this.formData.isQuantityValidated = false;
                            if (this.isFormValid == true) {
                                this.isFormValid = false;
                            }
                        }
                    }

                    this.copieMessage = message;
                }
                else {
                    if (parseInt(this.formData.quantity) <= 0) {
                        this.formData.quantity = 1;
                    }
                    this.isFormValid = true;
                    this.formData.isQuantityValidated = true;
                }

                //Attributes
                for (let group of this.formData.gruppi) {
                    for (let attribute of group.varianti) {
                        //-- Count all varianti options that should be visible
                        if (attribute.valori != null) {
                            attribute.valoriCount = attribute.valori.filter(x => x.isVisible == true).length;
                        }

                        if (attribute.tipo == 1) //NUMERIC
                        {
                            //The value shall be greater than zero
                            if (attribute.intFormValue < 0) {
                                if (this.isFormValid == true) {
                                    this.isFormValid = false;
                                }
                                attribute.isValidated = false;
                            }

                            else {
                                attribute.isValidated = true;
                            }
                        }
                        else if (attribute.tipo == 2) //DROPDOWN
                        {
                            //The value shall be greater than zero
                            if (attribute.intFormValue < 0) {
                                if (this.isFormValid == true) {
                                    this.isFormValid = false;
                                }

                                attribute.isValidated = false;
                            }

                            else {
                                attribute.isValidated = true;
                            }
                        }

                        else if (attribute.tipo == 5) //FORMAT
                        {
                            //Width validation
                            let convertedWidth = Number(attribute.numWidthFormValue);
                            let convertedHeight = Number(attribute.numHeightFormValue);
                            let convertedDepth = Number(attribute.numDepthFormValue);

                            //Checking if it is not mandatory
                            if (attribute.obbligatorio == false) {
                                //There is no validation if the three dimentions are not set
                                if (convertedWidth == 0 && convertedHeight == 0 && convertedDepth == 0) {
                                    attribute.isWidthValidated = true;
                                    attribute.isHeightValidated = true;
                                    attribute.isDepthValidated = true;
                                    continue;
                                }
                            }

                            //Checking if it is a valid number

                            if (isNaN(convertedWidth)) {
                                if (this.isFormValid == true) {
                                    this.isFormValid = false;
                                }

                                attribute.isWidthValidated = false;
                                attribute.widthErrorMex = "Inserisci un valore valido";
                            }

                            else {
                                if (attribute.max_base == 0) {
                                    //The value shall be greater than the minimum
                                    if (convertedWidth < attribute.min_base) {
                                        if (this.isFormValid == true) {
                                            this.isFormValid = false;
                                        }

                                        attribute.isWidthValidated = false;
                                        attribute.widthErrorMex = "Inserisci un valore maggiore o uguale a " + attribute.min_base
                                    }

                                    else {
                                        attribute.isWidthValidated = true;
                                        attribute.widthErrorMex = "";
                                    }
                                }

                                else {
                                    //3 - minbase = 0 - maxbase N - inserisci un valore compresto tra 0 e N
                                    //4 - minbase = N - maxbase M - inserisci un valore compresto tra 0 e N
                                    if (convertedWidth < attribute.min_base || convertedWidth > attribute.max_base) {
                                        if (this.isFormValid == true) {
                                            this.isFormValid = false;
                                        }

                                        attribute.isWidthValidated = false;
                                        attribute.widthErrorMex = "Inserisci un valore compreso tra " + attribute.min_base + " e " + attribute.max_base
                                    }

                                    else {
                                        attribute.isWidthValidated = true;
                                        attribute.widthErrorMex = "";
                                    }
                                }
                            }

                            //Height validation

                            //Checking if it is a valid number
                            if (isNaN(convertedHeight)) {
                                if (this.isFormValid == true) {
                                    this.isFormValid = false;
                                }

                                attribute.isHeightValidated = false;
                                attribute.heightErrorMex = "Inserisci un valore valido";
                            }

                            else {
                                if (attribute.max_altezza == 0) {
                                    //1 - min_altezza = 0 - max_altezza 0 - inserisci un valore maggiore id zero
                                    //2 - min_altezza = N - max_altezza 0 - inserisci un valore maggiore id N                      

                                    //The value shall be greater than the minimum
                                    if (convertedHeight < attribute.min_altezza) {
                                        if (this.isFormValid == true) {
                                            this.isFormValid = false;
                                        }

                                        attribute.isHeightValidated = false;
                                        attribute.heightErrorMex = "Inserisci un valore maggiore o uguale a " + attribute.min_altezza
                                    }

                                    else {
                                        attribute.isHeightValidated = true;
                                        attribute.heightErrorMex = "";
                                    }
                                }

                                else {
                                    //3 - min_altezza = 0 - max_altezza N - inserisci un valore compresto tra 0 e N
                                    //4 - min_altezza = N - max_altezza M - inserisci un valore compresto tra 0 e N
                                    if (convertedHeight < attribute.min_altezza || convertedHeight > attribute.max_altezza) {
                                        if (this.isFormValid == true) {
                                            this.isFormValid = false;
                                        }

                                        attribute.isHeightValidated = false;
                                        attribute.heightErrorMex = "Inserisci un valore compreso tra " + attribute.min_altezza + " e " + attribute.max_altezza
                                    }

                                    else {
                                        attribute.isHeightValidated = true;
                                        attribute.heightErrorMex = "";
                                    }
                                }
                            }

                            //Depth
                            if (attribute.hasDepth == true) {
                                //Checking if it is a valid number
                                if (isNaN(convertedDepth)) {
                                    if (this.isFormValid == true) {
                                        this.isFormValid = false;
                                    }

                                    attribute.isDepthValidated = false;
                                    attribute.depthErrorMex = "Inserisci un valore valido";
                                }

                                else {
                                    if (attribute.max_profondita == 0) {
                                        //1 - min_profondita = 0 - max_profondita 0 - inserisci un valore maggiore id zero
                                        //2 - min_profondita = N - max_profondita 0 - inserisci un valore maggiore id N                      

                                        //The value shall be greater than the minimum
                                        if (convertedDepth < attribute.min_profondita) {
                                            if (this.isFormValid == true) {
                                                this.isFormValid = false;
                                            }

                                            attribute.isDepthValidated = false;
                                            attribute.depthErrorMex = "Inserisci un valore maggiore o uguale a " + attribute.min_profondita
                                        }

                                        else {
                                            attribute.isDepthValidated = true;
                                            attribute.depthErrorMex = "";
                                        }
                                    }

                                    else {
                                        //3 - min_profondita = 0 - max_profondita N - inserisci un valore compresto tra 0 e N
                                        //4 - min_profondita = N - max_profondita M - inserisci un valore compresto tra 0 e N
                                        if (convertedDepth < attribute.min_profondita || convertedDepth > attribute.max_profondita) {
                                            if (this.isFormValid == true) {
                                                this.isFormValid = false;
                                            }

                                            attribute.isDepthValidated = false;
                                            attribute.depthErrorMex = "Inserisci un valore compreso tra " + attribute.min_profondita + " e " + attribute.max_profondita
                                        }

                                        else {
                                            attribute.isDepthValidated = true;
                                            attribute.depthErrorMex = "";
                                        }
                                    }
                                }
                            }

                        }
                    }
                }
            }


            getLabel(label) {
                let message;

                this.translate.get(label, this.translate).subscribe((res: string) => {
                    message = res;
                });

                return message;
            }
            /// Create model for passed in input to the calculation method
            getCalculationModel() {
                this.model.numCopie = this.formData.quantity;
                this.model.macrocategoryWizardId = 13;
                this.model.StrCustomerId = this.authService.GetUserId();
                this.model.wizardId = parseInt(this.resourceId);

                this.model.lavorazioniAccessorie = new Array<LavorazioniAccessorieModel>();

                for (let gruppo of this.formData.gruppi) {
                    for (let variante of gruppo.varianti) {
                        let lavorazione: LavorazioniAccessorieModel = new LavorazioniAccessorieModel();
                        //checkbox
                        if (parseInt(variante.tipo) == 0) {
                            lavorazione.lavorazioneId = variante.id;
                            if (variante.lavorazioneCheckValue.toString() == 'true') {
                                lavorazione.valoreLavorazione = "1";
                            }
                            else {
                                lavorazione.valoreLavorazione = "0";
                            }
                        }
                        //combo
                        else if (parseInt(variante.tipo) == 2) {
                            if (variante.intFormValue == "0") {
                                lavorazione.lavorazioneId = variante.id;
                                lavorazione.valoreLavorazione = "-1";
                            }

                            else {
                                lavorazione.lavorazioneId = variante.id;
                                lavorazione.valoreLavorazione = variante.intFormValue;
                            }
                        }
                        //numeric
                        else if (parseInt(variante.tipo) == 1) {
                            if (variante.intFormValue != null) {
                                lavorazione.lavorazioneId = variante.id;
                                lavorazione.valoreLavorazione = variante.intFormValue;
                            }
                        }
                        //formato
                        else if (parseInt(variante.tipo) == 5) {
                            if (variante.numWidthFormValue != null) {
                                lavorazione.lavorazioneId = variante.id;
                                lavorazione.tipo = variante.tipo;
                                if (variante.hasDepth == true) {
                                    lavorazione.numWidthFormValue = variante.numWidthFormValue;
                                    lavorazione.numHeightFormValue = variante.numHeightFormValue;
                                    lavorazione.numDepthFormValue = variante.numDepthFormValue;
                                }

                                else {
                                    lavorazione.numWidthFormValue = variante.numWidthFormValue;
                                    lavorazione.numHeightFormValue = variante.numHeightFormValue;
                                }
                            }
                        }
                        //textarea
                        else if (parseInt(variante.tipo) == 6) {
                            lavorazione.lavorazioneId = variante.id;
                            lavorazione.valoreLavorazione = variante.value;
                        }

                        if (lavorazione.lavorazioneId != null && lavorazione.valoreLavorazione != "-1") {
                            this.model.lavorazioniAccessorie.push(lavorazione);
                        }
                    }
                    this.isDataInitialized = true;
                }
                if (this.formData.calculationType != QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_RICHIESTA_PREVENTIVO) {
                    let calculationSub = this._quotingService.getCalculatedAp(this.model).subscribe(result => {
                        this.resultPrice = result;
                        this.isCalculatedProduct = true;

                        if (this.isCalculationTypeCalcolatoScontistica()) {
                            let scontisticaTable = this.resultPrice.TablePriceList;
                            if (scontisticaTable != null && scontisticaTable.length > 0) {
                                //Selecting the last available day result. (The cheapest)
                                for (let i = scontisticaTable.length - 1; i >= 0; i--) {
                                    let price = scontisticaTable[i];
                                    if (price.Price != -1) {
                                        this.setPriceResult(price);
                                        break;
                                    }
                                }
                            }
                        }
                        else if (this.isCalculationTypeListinoScontistica()) {
                            //Selecting first element
                            let tableScontisticaPriceListSliced = this.resultPrice.TableScontisticaPriceList.slice(1);
                            let breakFlag = false;
                            for (let priceRow of tableScontisticaPriceListSliced) {
                                let slicedPriceRow = priceRow.slice(1);

                                for (let price of slicedPriceRow) {
                                    if (price.Price != -1) {
                                        this.setListinoScontisticaPriceResult(price);
                                        breakFlag = true;
                                        break;
                                    }
                                }

                                if (breakFlag == true) {
                                    break;
                                }
                            }
                        }
                        else if (this.isCalculationTypeListino()) {
                            let tableScontisticaPriceListSliced = this.resultPrice.TablePriceList.slice(1);
                            if (tableScontisticaPriceListSliced.length > 0) {
                                let slicedPriceRow = tableScontisticaPriceListSliced[0];
                                if (slicedPriceRow.Price != -1) {
                                    this.setListinoPriceResult(slicedPriceRow);
                                }
                            }
                        }

                        this.subManager.add(calculationSub);

                        this.resultCalculation = true;
                        this.showErrorMessage = false;
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                    },
                        err => {
                            this.isCalculatedProduct = false;
                            this.showErrorMessage = true;
                            $('#quotingFormCalculationLoader').removeClass("overBlock");
                        }
                    );

                    this.subManager.add(calculationSub);
                }
                else {
                    $('#quotingFormCalculationLoader').removeClass("overBlock");

                }
                this.isDataInitialized = true;
            }

            isCustomerLoggedIn() {
                return this.loggedIdUser.isAuthenticated;
            }

            isCalculationTypeCalcolatoQuotigPrev() {
                let result: boolean = false;

                if (this.formData.calculationType == QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_RICHIESTA_PREVENTIVO) {
                    result = true;
                }

                return result;
            }

            isCalculationTypeCalcolato() {
                let result: boolean = false;
                if (this.formData.calculationType == QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO) {
                    result = true;
                }

                return result;
            }

            isCalculationTypeCalcolatoScontistica() {
                let result: boolean = false;
                if (this.formData.calculationType == QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_SCONTISTICA) {
                    result = true;
                }

                return result;
            }

            isCalculationTypeListino(): boolean {
                let retVal: boolean = false;
                if (this.formData.calculationType == QuotingConstants.WIZARD_CALCULATION_TYPE_LISTINO) {
                    retVal = true;
                }

                return retVal;
            }

            isCalculationTypeListinoScontistica(): boolean {
                let retVal: boolean = false;
                if (this.formData.calculationType == QuotingConstants.WIZARD_CALCULATION_TYPE_LISTINO_SCONTISTICA) {
                    retVal = true;
                }

                return retVal;
            }

            isCalculationTypeCalcolatoListino(): boolean {
                let retVal: boolean = false;
                if (this.formData.calculationType == QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_LISTINO) {
                    retVal = true;
                }

                return retVal;
            }

            isCalculationTypeCalcolatoListinoScontistica(): boolean {
                let retVal: boolean = false;
                if (this.formData.calculationType == QuotingConstants.WIZARD_CALCULATION_TYPE_CALCOLATO_LISTINO_SCONTISTICA) {
                    retVal = true;
                }

                return retVal;
            }

            ngAfterViewInit() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                $('#quotingFormLoader').hide();
                let altezza = $("#footer").outerHeight();
                let margintop = parseInt($("#footer").css('margin-top'));
                let paddingntop = parseInt($("#footer").css('padding-top'));
                altezza += margintop;
                altezza += paddingntop;

                let altezza1 = $(".footerplus").outerHeight() || 0;
                let margintop1 = parseInt($(".footerplus").css('margin-top')) || 0;
                let paddingntop1 = parseInt($(".footerplus").css('padding-top')) || 0;
                altezza += altezza1;
                altezza += margintop1;
                altezza += paddingntop1;

                let altezzaHead = $(".header-body").outerHeight();
                let margintopHead = parseInt($(".header-body").css('margin-bottom'));
                let paddingntopHead = parseInt($(".header-body").css('padding-bottom'));
                altezzaHead += margintopHead;
                altezzaHead += paddingntopHead;

                $("#quotingInformationTab").sticky({ topSpacing: altezzaHead, bottomSpacing: altezza });
                $("#quotingInformationTab-sticky-wrapper").height(0);
                this.pageIsInit = true;
            }

            checkEmailIsValid() {
                var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if (this.model.richiestaEmail == "" || !EMAIL_REGEXP.test(this.model.richiestaEmail)) {
                    this.model.isRichiestaEmailValid = false;
                }
                else {
                    this.model.isRichiestaEmailValid = true;
                }
            }

            setSelectedIndex(rowIndex: number, columnIndex: number) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            }

            setListinoScontisticaPriceResult(price: any) {
                if (price.Price == -1) {
                    return;
                }

                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            }

            isRowSelectedListino(rowIndex: number) {
                let result: boolean = false;

                if ((rowIndex) == this.currentRowIndex) {
                    result = true;
                }

                return result;
            }

            isRowSelected(rowIndex: number) {
                let result: boolean = false;

                if ((rowIndex + 1) == this.currentRowIndex) {
                    result = true;
                }

                return result;
            }

            isCellSelectedListino(rowIndex: number, columnIndex: number) {
                let result: boolean = false;

                if ((rowIndex) == this.currentRowIndex && (columnIndex) == this.currentColumnIndex) {
                    result = true;
                }

                return result;
            }

            isCellSelected(rowIndex: number, columnIndex: number) {
                let result: boolean = false;

                if ((rowIndex + 1) == this.currentRowIndex && (columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }

                return result;
            }

            isColumnSelectedListino(columnIndex: number) {
                let result: boolean = false;

                if ((columnIndex) == this.currentColumnIndex) {
                    result = true;
                }

                return result;
            }

            setPriceResult(price: any) {
                if (price.Price == -1) {
                    return;
                }

                //Deselecting the current price and selected the one passed in input
                for (let price of this.resultPrice.TablePriceList) {
                    price.IsSelected = false;
                }

                price.IsSelected = true;

                this.resultPrice.Currency = price.Currency;
                this.resultPrice.Imponibile = price.StrDiscountedPrice;
                this.resultPrice.DataId = price.DayId;
                this.resultPrice.DayName = price.DayName;
                this.resultPrice.DayNumber = price.DayNumber;
                this.resultPrice.QuantityID = price.QuantityId;
                this.resultPrice.Quantity = price.Quantity;

                this.resultPrice.UnitPrice = price.StrUnitPrice;
                this.resultPrice.Iva = price.StrIva;
                this.resultPrice.Total = price.StrDiscountedPriceWithTax;
                this.resultPrice.Weight = price.StrWeight;
                this.resultPrice.WeightUm = price.StrWeightUm;
            }

            isColumnSelected(columnIndex: number) {
                let result: boolean = false;

                if ((columnIndex + 1) == this.currentColumnIndex) {
                    result = true;
                }

                return result;
            }

            setTypePriceResult(type) {
                this.typePriceResult = type;
                if (type == "tax") {
                    $("#btnNoIva").removeClass("active");
                    $("#btnIva").addClass("active");
                }
                else {
                    $("#btnNoIva").addClass("active");
                    $("#btnIva").removeClass("active");
                }
            }

            setSelectedIndexListino(rowIndex: number, columnIndex: number) {
                this.currentRowIndex = rowIndex;
                this.currentColumnIndex = columnIndex;
            }

            setListinoPriceResult(price: any) {
                if (price.Price == -1) {
                    return;
                }
                this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
                this.setPriceResult(price);
            }

            addToCartApProduct() {
                let wizardId = parseInt(this.resourceId);
                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                let addToCartSub = this.cartService.addApProductToCart(wizardId, this.resultPrice.RowId).subscribe(result => {
                    this.cartService.updateCart(result);
                    this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    this.bootboxService.i18nAlert("productAddedToCart");
                    this.resultCalculation = true;
                },
                    err => {
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        this.bootboxService.i18nAlert("errorMex");
                        this.resultCalculation = true;
                    }
                );

                this.subManager.add(addToCartSub);
            }

            addToCartOtherProductCalcolatoScontistica(quantityId: number) {
                let wizardId = parseInt(this.resourceId);

                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                let sub = this.cartService.addOtherProductCalcolatoScontisticaToCart(wizardId, this.resultPrice.RowId, this.resultPrice.QuantityID).subscribe(result => {
                    this.cartService.updateCart(result);
                    this.getCalculationModel();
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    this.bootboxService.i18nAlert("productAddedToCart");
                    this.resultCalculation = true;
                },
                    err => {
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        this.bootboxService.i18nAlert("errorMex");
                        this.resultCalculation = true;
                    }
                );

                this.subManager.add(sub);
            }

            addToCartWizardListino(quantityId: number) {
                let wizardId = parseInt(this.resourceId);

                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");


                let sub = this.cartService.addOtherProductListinoToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, wizardId).subscribe(result => {
                    this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    this.bootboxService.i18nAlert("productAddedToCart");
                    this.resultCalculation = true;
                },
                    err => {
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        this.bootboxService.i18nAlert("errorMex");
                        this.resultCalculation = true;
                    }
                );

                this.subManager.add(sub);
            }

            addToCartWizardListinoScontistica(quantityId: number) {
                let wizardId = parseInt(this.resourceId);

                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                let sub = this.cartService.addOtherProductListinoScontisticaToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, wizardId, this.resultPrice.DataId).subscribe(result => {
                    this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    this.bootboxService.i18nAlert("productAddedToCart");
                    this.resultCalculation = true;
                },
                    err => {
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        this.bootboxService.i18nAlert("errorMex");
                        this.resultCalculation = true;
                    }
                );

                this.subManager.add(sub);
            }

            addToCartOtherProductCalcolatoListino(quantityId: number) {
                let wizardId = parseInt(this.resourceId);

                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");

                let sub = this.cartService.addOtherProductCalcolatoListinoToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, wizardId, this.resultPrice.Varianti).subscribe(result => {
                    this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    this.bootboxService.i18nAlert("productAddedToCart");
                    this.resultCalculation = true;
                },
                    err => {
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        this.bootboxService.i18nAlert("errorMex");
                        this.resultCalculation = true;
                    }
                );

                this.subManager.add(sub);
            }

            addToCartOtherProductCalcolatoListinoScontistica(quantityId: number) {
                let wizardId = parseInt(this.resourceId);

                this.resultCalculation = false;
                $('#quotingFormCalculationLoader').addClass("overBlock");
                let sub = this.cartService.addOtherProductCalcolatoListinoScontisticaToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, wizardId, this.resultPrice.DataId, this.resultPrice.Varianti).subscribe(result => {
                    this.cartService.updateCart(result);
                    $('#quotingFormCalculationLoader').removeClass("overBlock");
                    this.bootboxService.i18nAlert("productAddedToCart");
                    this.resultCalculation = true;
                },
                    err => {
                        $('#quotingFormCalculationLoader').removeClass("overBlock");
                        this.bootboxService.i18nAlert("errorMex");
                        this.resultCalculation = true;
                    }
                );

                this.subManager.add(sub);
            }

            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/document/widget/quoting/other-product-form.component.ts